import {
  Box,
  Grid,
  Modal,
  Paper,
  Tabs,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Tab from "@mui/material/Tab";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { format } from "timeago.js";
import useGetLoggedInUser from "services/hooks/LoggedInUser/useGetLoggedInUser";
import { socket } from "config/socket";
import { allNotification } from "redux/action/Notification/getNotifications";
import Avatargenerator from "../AvatarGenerator";
import sendEvents from "utils/sendEvents";
import { getProductDetailPath } from "utils/productDetailPath";
import { goToListingApp } from "utils/listingAppUrl";
import { getNotificationTab } from "utils/notificationTab";
import {
  fetchNotificationTabCounts,
  formatBadgeCount,
  formatNotificationReceivedAt,
} from "utils/notificationCounts";
import useGetAuthUser from "services/hooks/LoggedInUser/useGetAuthUser";
import {
  useGetCartCounts,
} from "services/hooks/ProductActions/useGetCartData";
import {
  DASHBOARD_PAGE_KEYS,
  hasDashboardPageAccess,
  hasLegacyCartAccess,
} from "utils/dashboardPageAccess";
import GlobalToast from "components/Toasts/GlobalToast";
import { DIGIO_ENABLED } from "config/features";
const Seller_cart_Icon =
  "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/HeaderIcon/SellerSide/seller_cart_icon.png";
const Seller_Notification_Icon =
  "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/HeaderIcon/SellerSide/seller_notification_icon.png";
const BXI_logo =
  "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/logos/bxi-logo-full.png";

const Header = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const [notificationDot, setNotificationDot] = useState(false);
  const [cartUpdateNotification, setCartUpdateNotification] = useState(false);
  const [totalCountBXIArray, SetTotalCountBXIArray] = useState([]);
  const [totalCountBuyerArray, setTotalCountBuyerArray] = useState([]);
  const [totalCountSellerArray, setTotalCountSellerArray] = useState([]);
  const [unReadCountOfAll, setUnReadCountOfAll] = useState(0);
  const [unReadCountOfBxi, setUnReadCountOfBxi] = useState(0);
  const [unReadCountOfBuyer, setUnReadCountOfBuyer] = useState(0);
  const [unReadCountOfSeller, setUnReadCountOfSeller] = useState(0);
  const [readCount, setReadCount] = useState(0);
  const [readNotifications, setReadNotifications] = useState([]);
  const [signedDocumentResponse, setSignedDocumentResponse] = useState(null);
  const location = useLocation();

  const [usehubType, setUserHubType] = useState(
    localStorage.getItem("userhubtype") || "buyer",
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data: loggedInUserData } = useGetLoggedInUser();
  const { data: AuthUserData } = useGetAuthUser();
  const { data: cartCounts, refetch: refetchCartCounts } = useGetCartCounts();

  const cartItemCount = useMemo(() => {
    const product = Number(cartCounts?.product) || 0;
    const voucher = Number(cartCounts?.voucher) || 0;
    const media = Number(cartCounts?.media) || 0;
    return product + voucher + media;
  }, [cartCounts]);

  const [UpdateNotiticationStatus, setUpdateNotiticationStatus] =
    useState(false);

  const { getNotification } = useSelector((state) => state.allNotifications);
  const MAX_MODAL_NOTIFICATIONS = 80;
  const getSafeMessage = (item) =>
    String(item?.message || item?.body || item?.title || "");
  // A v2 notification carries an authored `title` (the headline the copy was
  // written as) and a `body` (the supporting line). Every surface rendered only
  // `message` — which the fetch layer collapses to body||title — so the headline
  // was dropped and the bell showed the terser body instead of the notification
  // as authored. The legacy `type` field, used as the heading, does not exist on
  // v2 rows at all, so that heading rendered blank.
  const getSafeTitle = (item) =>
    String(item?.title || item?.type || "");
  const getSafeBody = (item) => {
    const body = String(item?.body || item?.message || "");
    return body === getSafeTitle(item) ? "" : body;
  };
  const notificationList = useMemo(
    () =>
      Array.isArray(getNotification?.notifications)
        ? getNotification.notifications
        : [],
    [getNotification?.notifications],
  );

  const UpdateNotifications = async (data, { forceRead } = {}) => {
    const nextRead =
      typeof forceRead === "boolean" ? forceRead : data?.read !== true;
    if (Boolean(data?.read) === nextRead) return;

    const markReceiverId = String(
      data?.receiverId || primaryReceiverId || fallbackReceiverId || "",
    );
    const tab = getNotificationTab(data);
    const delta = nextRead ? -1 : 1;

    setReadCount((n) => Math.max(0, (Number(n) || 0) + (nextRead ? 1 : -1)));
    setUnReadCountOfAll((n) => {
      const nextAll = Math.max(0, (Number(n) || 0) + delta);
      setNotificationDot(nextAll > 0);
      return nextAll;
    });
    if (tab === "purchase") {
      setUnReadCountOfBuyer((n) => Math.max(0, (Number(n) || 0) + delta));
    } else if (tab === "sell") {
      setUnReadCountOfSeller((n) => Math.max(0, (Number(n) || 0) + delta));
    } else {
      setUnReadCountOfBxi((n) => Math.max(0, (Number(n) || 0) + delta));
    }

    try {
      await axios.patch(
        `v2/notifications/${data._id}/read?receiverId=${encodeURIComponent(markReceiverId)}`,
        { read: nextRead },
        { withCredentials: true },
      );
    } catch (err) {
      // refresh below
    }

    if (primaryReceiverId) {
      dispatch(
        allNotification(primaryReceiverId, "", {
          page: 1,
          limit: 80,
          receiverId: primaryReceiverId,
          fallbackReceiverId,
        }),
      );
      fetchNotificationTabCounts(primaryReceiverId)
        .then((counts) => {
          setUnReadCountOfAll(counts.unreadAll);
          setUnReadCountOfBxi(counts.unreadBxi);
          setUnReadCountOfBuyer(counts.unreadPurchase);
          setUnReadCountOfSeller(counts.unreadSell);
          setReadCount(counts.readCount);
          setNotificationDot(counts.unreadAll > 0);
        })
        .catch(() => {});
    }
  };

  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    if (getNotification) {
      // Lists for modal tabs still come from the loaded page; badge numbers are
      // refreshed from fetchNotificationTabCounts (full totals).
      const messagesWithCountBXI = notificationList.filter(
        (item) => getNotificationTab(item) === "bxi",
      );
      const messagesWithCountBuyer = notificationList.filter(
        (item) => getNotificationTab(item) === "purchase",
      );
      const messagesWithCountSeller = notificationList.filter(
        (item) => getNotificationTab(item) === "sell",
      );

      SetTotalCountBXIArray(messagesWithCountBXI);
      setTotalCountBuyerArray(messagesWithCountBuyer);
      setTotalCountSellerArray(messagesWithCountSeller);

      const serverUnread = Number(getNotification?.unreadCount);
      if (Number.isFinite(serverUnread)) {
        setUnReadCountOfAll(serverUnread);
        setNotificationDot(serverUnread > 0);
      }
    }
  }, [notificationList, getNotification?.unreadCount]);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [value, setValue] = React.useState(
    AuthUserData?.data?.superAdmin ? "1" : "2",
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const login_User = loggedInUserData?.data?._id;
  const login_Company =
    loggedInUserData?.data?.companyId?._id ||
    loggedInUserData?.data?.companyId ||
    "";
  const primaryReceiverId = login_Company || login_User || "";
  const fallbackReceiverId =
    login_Company && login_User
      ? primaryReceiverId === login_Company
        ? login_User
        : login_Company
      : "";

  useEffect(() => {
    if (value !== "5" || !primaryReceiverId) return undefined;
    let active = true;
    (async () => {
      try {
        const buildUrl = (receiverId) =>
          `v2/notifications?page=1&pageSize=80&status=READ&receiverId=${encodeURIComponent(
            receiverId,
          )}`;
        let { data } = await axios.get(buildUrl(primaryReceiverId), {
          withCredentials: true,
        });
        let items = Array.isArray(data?.data?.items) ? data.data.items : [];
        if (
          items.length === 0 &&
          fallbackReceiverId &&
          fallbackReceiverId !== primaryReceiverId
        ) {
          const fallback = await axios.get(buildUrl(fallbackReceiverId), {
            withCredentials: true,
          });
          data = fallback?.data;
          items = Array.isArray(data?.data?.items) ? data.data.items : [];
        }
        if (!active) return;
        setReadNotifications(
          items.map((item) => ({
            ...item,
            message: item?.body || item?.title || "",
            read: true,
          })),
        );
        const total = Number(data?.data?.total);
        if (Number.isFinite(total)) setReadCount(total);
      } catch (_) {
        if (active) setReadNotifications([]);
      }
    })();
    return () => {
      active = false;
    };
  }, [
    value,
    primaryReceiverId,
    fallbackReceiverId,
    getNotification?.unreadCount,
  ]);

  useEffect(() => {
    if (primaryReceiverId) {
      dispatch(
        allNotification(primaryReceiverId, "", {
          page: 1,
          limit: 80,
          receiverId: primaryReceiverId,
          fallbackReceiverId,
        }),
      );
    }
  }, [dispatch, primaryReceiverId, fallbackReceiverId]);

  useEffect(() => {
    if (!primaryReceiverId) return;
    fetchNotificationTabCounts(primaryReceiverId)
      .then((counts) => {
        setUnReadCountOfAll(counts.unreadAll);
        setUnReadCountOfBxi(counts.unreadBxi);
        setUnReadCountOfBuyer(counts.unreadPurchase);
        setUnReadCountOfSeller(counts.unreadSell);
        setReadCount(counts.readCount);
        setNotificationDot(counts.unreadAll > 0);
      })
      .catch(() => {});
  }, [primaryReceiverId, getNotification?.unreadCount]);

  const socketListenersRegistered = useRef(false);

  useEffect(() => {
    // Prevent duplicate listener registration
    if (socketListenersRegistered.current) {
      return;
    }

    const handleConnect = () => {
      if (login_User) {
        socket.emit("join", String(login_User));
      }
      if (login_Company) {
        socket.emit("join", String(login_Company));
      }
    };

    const handleConnectError = (error) => {
      socket.connect();
    };

    const handleDisconnect = (reason) => {
    };

    const handleReconnect = (attemptNumber) => {
      console.log("Reconnected after", attemptNumber, "attempts");
    };

    const handleReconnectError = (error) => {
      console.log("Reconnection error:", error);
    };

    const handleNotificationS = (data) => {
      if (data !== null) {
        setNotificationDot(true);
        if (primaryReceiverId) {
          dispatch(
            allNotification(primaryReceiverId, "", {
              page: 1,
              limit: 80,
              receiverId: primaryReceiverId,
              fallbackReceiverId,
            }),
          );
        }
      }
    };

    const handleQueryNotificationR = (data) => {
      if (data !== null) {
        setNotificationDot(true);
        if (primaryReceiverId) {
          dispatch(
            allNotification(primaryReceiverId, "", {
              page: 1,
              limit: 80,
              receiverId: primaryReceiverId,
              fallbackReceiverId,
            }),
          );
        }
      }
    };

    const handleOrderTracking = (data) => {
      if (data !== null) {
        setNotificationDot(true);
        if (primaryReceiverId) {
          dispatch(
            allNotification(primaryReceiverId, "", {
              page: 1,
              limit: 80,
              receiverId: primaryReceiverId,
              fallbackReceiverId,
            }),
          );
        }
      }
    };

    const handleCartUpdate = () => {
      setCartUpdateNotification(true);
      refetchCartCounts();
    };

    socket.on("connect", handleConnect);
    socket.on("connect_error", handleConnectError);
    socket.on("disconnect", handleDisconnect);
    socket.on("reconnect", handleReconnect);
    socket.on("reconnect_error", handleReconnectError);
    socket.on("notification:inapp", handleNotificationS);
    socket.on("QueryNotificationR", handleQueryNotificationR);
    socket.on("OrderTracking", handleOrderTracking);
    socket.on("CartUpdate", handleCartUpdate);

    socketListenersRegistered.current = true;

    return () => {
      socket.off("connect", handleConnect);
      socket.off("connect_error", handleConnectError);
      socket.off("disconnect", handleDisconnect);
      socket.off("reconnect", handleReconnect);
      socket.off("reconnect_error", handleReconnectError);
      socket.off("notification:inapp", handleNotificationS);
      socket.off("QueryNotificationR", handleQueryNotificationR);
      socket.off("OrderTracking", handleOrderTracking);
      socket.off("CartUpdate", handleCartUpdate);

      socketListenersRegistered.current = false;
    };
  }, [
    dispatch,
    login_User,
    login_Company,
    primaryReceiverId,
    fallbackReceiverId,
    refetchCartCounts,
  ]);

  useEffect(() => {
    if (login_User && socket.connected) {
      socket.emit("join", String(login_User));
    }
    if (login_Company && socket.connected) {
      socket.emit("join", String(login_Company));
    }
  }, [login_User, login_Company]);

  const pathname = location.pathname;

  const handleBuyerSellerType = (props) => {
    localStorage.setItem("userhubtype", props);
  };

  useEffect(() => {
    const currentPath = pathname;
    if (
      currentPath === "/home" ||
      currentPath === "/home/profile" ||
      currentPath === "/home/cart" ||
      currentPath === "/home/dashboard" ||
      currentPath === "/home/trackorders" ||
      currentPath === "/home/purchaseorderlist" ||
      currentPath === "/home/order-requests" ||
      currentPath.startsWith("/home/myorderlist") ||
      currentPath.startsWith("/home/voucherorderlist") ||
      currentPath.startsWith("/home/productpilist") ||
      currentPath.startsWith("/home/mediapurchaseorder") ||
      currentPath.startsWith("/home/mediapilist") ||
      currentPath.startsWith("/home/wishlist") ||
      currentPath.startsWith("/home/bulk-purchase")
    ) {
      if (
        currentPath === "/home/trackorders" ||
        currentPath === "/home/purchaseorderlist" ||
        currentPath === "/home/order-requests"
      ) {
        const currentHubType = localStorage.getItem("userhubtype");
        if (currentHubType === "seller") {
          setUserHubType("seller");
          return;
        }
      }
      handleBuyerSellerType("buyer");
      setUserHubType("buyer");
    } else if (
      currentPath.startsWith("/home/seller") ||
      currentPath.startsWith("/home/sellerorderlist") ||
      currentPath.startsWith("/home/sellerdetailedordersummary") ||
      currentPath.startsWith("/home/sellervoucherorderlist") ||
      currentPath.startsWith("/home/sellerperformainvoice") ||
      currentPath.startsWith("/home/sellerpurchaseorder") ||
      currentPath.startsWith("/home/sellerpilist") ||
      currentPath.startsWith("/home/sellermediapo") ||
      currentPath.startsWith("/home/sellermediapilist") ||
      currentPath.startsWith("/home/orderdetailsseller") ||
      currentPath.endsWith("/seller")
    ) {
      handleBuyerSellerType("seller");
      setUserHubType("seller");
    } else if (currentPath.endsWith("/buyer")) {
      handleBuyerSellerType("buyer");
      setUserHubType("buyer");
    } else {
      const storedVariable = localStorage.getItem("userhubtype");
      if (storedVariable) {
        setUserHubType(storedVariable);
      }
    }
  }, [AuthUserData, pathname]);

  const clearLocaStorageForBreadCrumb = () => {
    localStorage.removeItem("breadcrumbHistory");
  };

  const {
    data: userData,
  } = useGetLoggedInUser();

  const handleClickRedirect = ({ message, userHubType, notification }) => {
    // Opening a notification counts as reading it.
    if (notification && notification.read !== true) {
      UpdateNotifications(notification, { forceRead: true });
    }

    // Listing pages live in the seller-hub app and are reached through a signed
    // handoff, so their notifications cannot be followed as a path.
    if (/^(BW_LISTING|USER_LISTING)\./.test(notification?.eventKey || "")) {
      goToListingApp({ source: "dashboard" });
      return;
    }
    const rawPath =
      notification?.redirectPath ||
      notification?.metadata?.redirectPath ||
      notification?.metadata?.path;
    if (rawPath && typeof rawPath === "string") {
      const p = rawPath.trim();
      if (p.startsWith("http://") || p.startsWith("https://")) {
        window.location.href = p;
      } else {
        navigate(p.startsWith("/") ? p : `/${p}`);
      }
      return;
    }
    if (
      message?.includes("approved by our team") ||
      message?.includes("disapproved by our team") ||
      message?.includes("Hurray! You have successfully uploaded your product")
    ) {
      const productIdRegex = /productId\s*:\s*(\w+)/;
      const match = message.match(productIdRegex);

      let productId = null;
      if (match && match[1]) {
        productId = match[1];
      }

      const productTypeMatch = message.match(/productType:(\w+)/);

      let productType;
      if (productTypeMatch) {
        productType = productTypeMatch[1];
      }

      if (productId && productType === "Product") {
        navigate(
          getProductDetailPath({ _id: productId, ListingType: "Product" }),
        );
      } else if (productId && productType === "Media") {
        navigate(
          getProductDetailPath({ _id: productId, ListingType: "Media" }),
        );
      } else if (productId && productType === "Voucher") {
        navigate(
          getProductDetailPath({ _id: productId, ListingType: "Voucher" }),
        );
      }
    } else if (message.includes("rejected")) {
      navigate("/home/order-requests", {
        state: {
          tab: "Sold",
        },
      });
    } else if (message.includes("has confirmed delivery")) {
      navigate("/home/order-requests", { state: { tab: "Sold" } });
    } else if (
      message.includes("better benefits!") ||
      message.includes("Profile now to")
    ) {
      navigate("/home/planpricing");
    } else if (message.includes("PI generated by you has been confirmed")) {
      navigate("/home/sellerpilist");
    } else if (message.includes("successfully uploaded your product")) {
      console.log("successfully uploaded your product");
    } else if (message.includes("E-invoice for order")) {
      const productIdRegex = /productId\s*:\s*(\w+)/;
      const match = message.match(productIdRegex);

      let productId = null;
      if (match && match[1]) {
        productId = match[1];
      }

      const productTypeMatch = message.match(/productType:(\w+)/);

      let productType;
      if (productTypeMatch) {
        productType = productTypeMatch[1];
      }
      navigate(`/home/orderdetails/${productId}/${productType}/seller`);
    } else if (message.includes("for E-invoice of you recent order")) {
      const productIdRegex = /productId\s*:\s*(\w+)/;
      const match = message.match(productIdRegex);

      let productId = null;
      if (match && match[1]) {
        productId = match[1];
      }

      const productTypeMatch = message.match(/productType:(\w+)/);

      let productType;
      if (productTypeMatch) {
        productType = productTypeMatch[1];
      }
      navigate(`/home/orderdetails/${productId}/${productType}/buyer`);
    } else if (
      message.includes("Proforma Invoice") ||
      message.includes("Attention! PI for the order id") ||
      message.includes("Proforma Invoice (PI) for Order id") ||
      message.includes("has been accepted by the Buyer and payment is done.") ||
      message.includes(
        "Attention! Your Proforma Invoice has been rejected by the Buyer.",
      )
    ) {
      const productIdRegex = /piid\s*:\s*(\w+)/;
      const match = message.match(productIdRegex);

      let piId = null;
      if (match && match[1]) {
        piId = match[1];
      }
      if (piId) {
        navigate(`/home/performainvoice/${piId}`);
      }
    } else if (message.includes("has generated PI for Order Id")) {
      const productIdRegex = /piid\s*:\s*(\w+)/;
      const match = message.match(productIdRegex);

      let piId = null;
      if (match && match[1]) {
        piId = match[1];
      }
      if (piId) {
        navigate(`/home/performainvoice/${piId}`);
      }
    } else if (
      message.includes("item") ||
      message.includes("shipment") ||
      message.includes("picked") ||
      message.includes("delivery") ||
      message.includes("AWB")
    ) {
      navigate("/home/trackorders");
    } else if (message.includes("Price And Quantity")) {
      // navigateToStandaloneSellerHub();
      console.log("Price And Quantity");
    } else if (message.includes("Debited") || message.includes("recovered")) {
      navigate("/home/dashboard");
    } else if (message.includes("credit") || message.includes("Credit")) {
      // @deprecated Feb 2026: Credit status page removed, redirect to dashboard
      navigate("/home/dashboard");
    } else if (message.includes("Credited") || message.includes("Balance")) {
      navigate("/home/dashboard");
    } else if (message.includes("delivered")) {
      navigate("/home/myorderlist");
    } else if (message.includes("Complete your Profile")) {
      navigate("/home/profile");
    } else if (message.includes("PO for your product has been generated")) {
      const productIdRegex = /poid\s*:\s*(\w+)/;
      const match = message.match(productIdRegex);

      let poId = null;
      if (match && match[1]) {
        poId = match[1];
      }

      if (poId) {
        navigate(`/home/sellerdetailedordersummary/${poId}`);
      }
    } else if (
      message.includes("Attention! PO for the order id") ||
      message.includes("Purchase Order (PO) for Order Id") ||
      message.includes("has been partially accepted by the")
    ) {
      const productIdRegex = /poid\s*:\s*(\w+)/;
      const match = message.match(productIdRegex);

      let poId = null;
      if (match && match[1]) {
        poId = match[1];
      }

      if (poId) {
        navigate(`/home/sellerdetailedordersummary/${poId}`);
      }
    } else if (
      message?.includes("Hurray! Your voucher codes for order") ||
      message?.includes("activate the voucher codes for order")
    ) {
      navigate("/home/voucherorderlist");
    } else if (
      message.includes(
        "Attention! We have suggested some changes to your product, uploaded on BXI Marketplace.",
      )
    ) {
      navigate("/home/order-requests", {
        state: {
          tab: "Admin Review",
        },
      });
    } else if (message?.includes("delisted") || message?.includes("delist")) {
      const productIdRegex = /productId\s*:\s*(\w+)/;
      const match = message.match(productIdRegex);

      let pid = null;
      if (match && match[1]) {
        pid = match[1];
      }

      const productType = /productType\s*:\s*(\w+)/;
      const productMatch = message.match(productType);

      let ptype = null;
      if (productMatch && productMatch[1]) {
        ptype = productMatch[1];
      }

      if (pid && ptype === "Media") {
        navigate(`/home/mediaonlineproductpreview/${pid}`);
      } else if (pid && ptype === "Product") {
        navigate(`/home/allproductpreview/${pid}`);
      } else if (pid && ptype === "Voucher") {
        navigate(`/home/spacificvoucher/${pid}`);
      }
    } else if (message?.includes("Action Required! Uploading of product")) {
      // navigateToStandaloneSellerHub({ tab: 'In Draft' });
      console.log("Action Required! Uploading of product");
    }
    handleClose();
    clearLocaStorageForBreadCrumb();
  };

  const fetchSignedDocument = async (documentId) => {
    try {
      const response = await axios
        .post(`/digio/document`, {
          document_id: documentId,
        })
        .then((res) => {
          setSignedDocumentResponse(res?.data?.data?.agreement_status);
          return res;
        });

      return response.data;
    } catch (error) {
      return null;
    }
  };
  useEffect(() => {
    // Only a member with a Digio agreement on file has a status to check, and
    // with Digio switched off there is nothing to sign — skip the round trip.
    const documentId = userData?.data?.digioResponse?.id;
    if (!DIGIO_ENABLED || !documentId) return;
    fetchSignedDocument(documentId);
  }, [userData?.data?.digioResponse?.id]);

  const allTabItems = notificationList;
  // Fallback to all notifications so users don't see an empty popup
  // when legacy/new message formats don't include explicit "BXI" text.
  const bxiTabItems = totalCountBXIArray?.length
    ? totalCountBXIArray
    : notificationList;
  const buyTabItems = totalCountBuyerArray;
  const sellTabItems = totalCountSellerArray;
  const readTabItems = readNotifications;
  const currentTabItems =
    value === "1"
      ? allTabItems
      : value === "2"
        ? bxiTabItems
        : value === "3"
          ? buyTabItems
          : value === "5"
            ? readTabItems
            : sellTabItems;

  if (signedDocumentResponse === "Requested") {
    return (
      <Box
        sx={{
          position: "relative",
          width: "95%",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          flexDirection: "row",
          borderBottom: "2px solid #EDEFF2;",
          height: "55px",
          pl: "50px",
          background: "transparent",
        }}
        elevation={0}
      >
        <Box
          sx={{
            display: "flex",
            width: "auto",
            justifyContent: "flex-start",
            alignContent: "center",
            alignItems: "center",
            gap: "5px",
            maxWidth: "220px",
            marginLeft: "20px",
          }}
        >
          <Avatargenerator companyname={userData?.data?.companyName} />
          <Typography
            sx={{
              ...UserNameTextStyle,
              width: "300px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              mr: 1,
            }}
          >
            {userData?.data?.companyName}
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <React.Fragment>
      <Paper
        sx={{
          position: "relative",
          borderBottom: "2px solid #EDEFF2",
          minHeight: {
            xl: "55px",
            lg: "55px",
            md: "55px",
            sm: "60px",
            xs: "60px",
          },
          height: {
            xl: "55px",
            lg: "55px",
            md: "55px",
            sm: "auto",
            xs: "auto",
          },
          pl: { xl: "50px", lg: "50px", md: "30px", sm: "16px", xs: "12px" },
          pr: { xl: "0px", lg: "0px", md: "0px", sm: "16px", xs: "0px" },
          background: "transparent",
        }}
        elevation={0}
      >
        <Paper
          sx={{
            width: "100%",
            maxWidth: "100%",
            overflowX: "hidden",
            borderRadius: "0px",
            boxShadow: "none",
            display: "flex",
            justifyContent: {
              xs: "space-between",
              sm: "space-between",
              md: "space-between",
            },
            background: "transparent",
            alignItems: "center",
            alignContent: "center",
            minHeight: "100%",
            py: { xs: 0.5, sm: 0.5, md: 0 },
            position: "relative",
          }}
          elevation={0}
        >
          <Grid
            container
            spacing={{ xs: 0, sm: 1, md: 0 }}
            sx={{
              position: "relative",
              alignItems: "center",
              justifyContent: { xs: "space-between", sm: "initial" },
              flexWrap: "nowrap",
            }}
          >
            <Grid item xs={6} sm={4} md={4} lg={4} xl={4}>
              <Box
                sx={{
                  display: { xs: "flex", sm: "flex", md: "flex" },
                  justifyContent: {
                    xs: "flex-start",
                    sm: "center",
                    md: "flex-start",
                  },
                  alignItems: "center",
                  width: "100%",
                  mb: { xs: 0, sm: 0.5, md: 0 },
                }}
              >
                <a
                  href={"/home"}
                  style={{
                    textDecoration: "none",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      flexDirection: "row",
                      gap: { xs: "6px", sm: "6px", md: "8px" },
                      textDecoration: "none",
                      marginLeft: { xs: 0, sm: 0, md: "20px" },
                      mt: 1,
                    }}
                    onClick={clearLocaStorageForBreadCrumb}
                  >
                    <img
                      src={BXI_logo}
                      alt="BXI logo"
                      title="BXI Logo Image"
                      style={{
                        width: isMobile ? "32px" : isTablet ? "30px" : "32px",
                        height: "auto",
                        marginLeft: isMobile ? "45px" : "0px",
                        marginBottom: isMobile ? "5px" : "0px",
                        display: "block",
                        flexShrink: 0,
                      }}
                    />
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: {
                          xl: "10px",
                          lg: "10px",
                          md: "9px",
                          sm: "8px",
                          xs: "7px",
                        },
                        textAlign: "center",
                        color: "#111034",
                        display: { xs: "none", sm: "block", md: "block" },
                        marginTop: "17px",
                      }}
                    >
                      BARTER EXCHANGE OF INDIA
                    </Typography>
                  </Box>
                </a>
              </Box>
            </Grid>
            <Grid
              item
              xs={6}
              sm={8}
              md={4}
              lg={4}
              xl={4}
              sx={{
                display: { xs: "flex", sm: "flex", md: "flex" },
                order: 0,
                marginLeft: { md: "auto", lg: "auto", xl: "auto" },
                justifyContent: {
                  xs: "flex-end",
                  sm: "flex-end",
                  md: "flex-end",
                  lg: "flex-end",
                  xl: "flex-end",
                },
                pr: {
                  xl: "30px",
                  lg: "30px",
                  md: "30px",
                  sm: "16px",
                  xs: "12px",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  width: { xs: "auto", sm: "auto", md: "auto" },
                  justifyContent: {
                    xs: "flex-end",
                    sm: "flex-end",
                    md: "flex-end",
                    lg: "flex-end",
                    xl: "flex-end",
                  },
                  alignContent: "center",
                  alignItems: "center",
                  gap: { xs: "4px", sm: "6px", md: "12px" },
                  mt: { xl: 0, lg: 0, md: 0, sm: 0.5, xs: 0.5 },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: {
                      xs: "center",
                      sm: "center",
                      md: "flex-end",
                      lg: "flex-end",
                      xl: "flex-end",
                    },
                    alignItems: "center",
                    alignContent: "center",
                    gap: { xs: "4px", sm: "6px", md: "8px" },
                    flexWrap: "nowrap",
                  }}
                >
                  {/* {process.env.NODE_ENV !== "production" && (
                    <Box
                      sx={{
                        px: 1,
                        py: 0.35,
                        borderRadius: "999px",
                        border: "1px solid",
                        borderColor: isSocketConnected ? "#16a34a" : "#dc2626",
                        backgroundColor: isSocketConnected
                          ? "rgba(22,163,74,0.1)"
                          : "rgba(220,38,38,0.1)",
                        color: isSocketConnected ? "#166534" : "#991b1b",
                        fontSize: { xs: "9px", sm: "10px", md: "11px" },
                        fontWeight: 600,
                        lineHeight: 1.2,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {isSocketConnected
                        ? `Socket: Connected${socketSessionId ? ` (${String(socketSessionId).slice(0, 8)})` : ""}`
                        : "Socket: Disconnected"}
                    </Box>
                  )} */}
                  {hasDashboardPageAccess(
                    AuthUserData?.data?.rightsarray,
                    DASHBOARD_PAGE_KEYS.NOTIFICATIONS,
                    AuthUserData?.data?.superAdmin,
                  ) && (
                    <Box
                      sx={{
                        ...ButtonsStyle,
                        position: "relative",
                        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px;",
                      }}
                    >
                      {notificationDot === true ? (
                        <Box
                          sx={{
                            display: "flex",
                            bgcolor: "red",
                            height: { xs: "16px", sm: "17px", md: "18px" },
                            width: { xs: "16px", sm: "17px", md: "18px" },
                            borderRadius: { xs: "8px", sm: "8.5px", md: "9px" },
                            position: "absolute",
                            justifyContent: "center",
                            alignContent: "center",
                            alignItems: "center",
                            top: {
                              xl: "-8px",
                              lg: "-8px",
                              md: "-8px",
                              sm: "-6px",
                              xs: "-6px",
                            },
                            right: {
                              xl: "7px",
                              lg: "7px",
                              md: "7px",
                              sm: "4px",
                              xs: "4px",
                            },
                            zIndex: 1,
                            color: "white",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: { xs: "8px", sm: "8.5px", md: "9px" },
                              lineHeight: 1,
                            }}
                          >
                            {formatBadgeCount(unReadCountOfAll)}
                          </Typography>
                        </Box>
                      ) : null}

                      <img
                        src={
                          usehubType === "seller"
                            ? Seller_Notification_Icon
                            : "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/HeaderIcon/Notification.png"
                        }
                        alt="Notification Icon"
                        title="Notification Icon"
                        style={{
                          width: isMobile ? "14px" : isTablet ? "16px" : "18px",
                          height: isMobile
                            ? "14px"
                            : isTablet
                              ? "16px"
                              : "18px",
                          cursor: "pointer",
                          padding: isMobile ? "8px" : isTablet ? "9px" : "10px",
                        }}
                        onClick={() => {
                          handleOpen();
                          sendEvents("Click on Notification button");
                          clearLocaStorageForBreadCrumb();
                        }}
                      />
                      <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={style}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              mb: 1.5,
                            }}
                          >
                            <Typography
                              sx={{
                                fontFamily:
                                  '"Google Sans Flex", "Inter", sans-serif',
                                fontWeight: 500,
                                fontSize: { xs: 17, sm: 18, md: 19 },
                                color: "#2261a2",
                              }}
                            >
                              Notifications
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                gap: 1.5,
                                alignItems: "center",
                              }}
                            >
                              <Link
                                to={"/home/fullscreennotification"}
                                style={{ textDecoration: "none" }}
                                onClick={() => {
                                  handleClose();
                                  sendEvents(
                                    "Click on Notification open button",
                                  );
                                  clearLocaStorageForBreadCrumb();
                                }}
                              >
                                <Box
                                  component="img"
                                  src="https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/HeaderIcon/FullScreenIcon.svg"
                                  sx={HeaderIcons}
                                />
                              </Link>
                              <Box
                                component="img"
                                src="https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/HeaderIcon/CloseIconForNotification.svg"
                                onClick={() => {
                                  handleClose();
                                  clearLocaStorageForBreadCrumb();
                                  sendEvents(
                                    "Click on close Notification button",
                                  );
                                }}
                                sx={{ ...HeaderIcons }}
                              />
                            </Box>
                          </Box>

                          <Tabs
                            value={value}
                            onChange={handleChange}
                            variant="scrollable"
                            scrollButtons="auto"
                            sx={{
                              mb: 1.5,
                              minHeight: "40px",
                              "& .MuiTabs-indicator": {
                                height: "2px",
                                backgroundColor: "#3186ff",
                                borderRadius: "999px",
                              },
                              "& .MuiTab-root": {
                                minHeight: "40px",
                                px: 2,
                                textTransform: "none",
                                fontFamily:
                                  '"Google Sans Flex", "Inter", sans-serif',
                                fontSize: "13px",
                                color: "#64748b",
                                borderRadius: 1,
                                transition:
                                  "all 180ms cubic-bezier(0.22, 1, 0.36, 1)",
                                "&:hover": {
                                  color: "#2261a2",
                                  backgroundColor: "rgba(183, 191, 217, 0.1)",
                                },
                                "&:focus-visible": {
                                  outline: "2px solid #2563eb",
                                  outlineOffset: "2px",
                                },
                              },
                              "& .Mui-selected": {
                                color: "#2261a2",
                                fontWeight: 600,
                                backgroundColor: "rgba(255,255,255,0.95)",
                                boxShadow: "0 2px 8px rgba(34, 97, 162, 0.18)",
                                border: "1px solid rgba(34, 97, 162, 0.22)",
                              },
                            }}
                          >
                            {(AuthUserData?.data?.superAdmin ||
                              (AuthUserData?.data?.rightsarray?.SELLER?.includes?.(
                                "NOTIFICATIONS",
                              ) &&
                                AuthUserData?.data?.rightsarray?.BUYER?.includes?.(
                                  "NOTIFICATIONS",
                                ))) && (
                              <Tab
                                label={`All (${formatBadgeCount(unReadCountOfAll || 0)})`}
                                value="1"
                              />
                            )}
                            <Tab
                              label={`BXI (${formatBadgeCount(unReadCountOfBxi || 0)})`}
                              value="2"
                            />
                            {(AuthUserData?.data?.superAdmin ||
                              AuthUserData?.data?.rightsarray?.BUYER?.includes?.(
                                "NOTIFICATIONS",
                              )) && (
                              <Tab
                                label={`Buy (${formatBadgeCount(unReadCountOfBuyer || 0)})`}
                                value="3"
                              />
                            )}
                            {(AuthUserData?.data?.superAdmin ||
                              AuthUserData?.data?.rightsarray?.SELLER?.includes?.(
                                "NOTIFICATIONS",
                              )) && (
                              <Tab
                                label={`Sell (${formatBadgeCount(unReadCountOfSeller || 0)})`}
                                value="4"
                              />
                            )}
                            <Tab
                              label={`Read (${formatBadgeCount(readCount || 0)})`}
                              value="5"
                            />
                          </Tabs>

                          <Box
                            sx={{
                              maxHeight: {
                                xs: "300px",
                                sm: "280px",
                                md: "260px",
                              },
                              overflowY: "auto",
                              pr: 0.5,
                              display: "flex",
                              flexDirection: "column",
                              gap: 1,
                            }}
                          >
                            {currentTabItems?.slice(0, MAX_MODAL_NOTIFICATIONS)
                              ?.length ? (
                              currentTabItems
                                .slice(0, MAX_MODAL_NOTIFICATIONS)
                                .map((item, idx) => {
                                  const heading = getSafeTitle(item);
                                  const maskedMessage = getSafeBody(
                                    item,
                                  ).replace(
                                    /productId:.*|poid:.*|piid:.*|productType:.*/g,
                                    "",
                                  );
                                  return (
                                    <Box
                                      key={`${item?._id || "n"}-${idx}`}
                                      sx={{
                                        borderRadius: "16px",
                                        background: "rgba(183, 191, 217, 0.1)",
                                        border:
                                          "1px solid rgba(33, 34, 38, 0.06)",
                                        px: 1.5,
                                        py: 1.25,
                                        transition:
                                          "all 220ms cubic-bezier(0.22, 1, 0.36, 1)",
                                        "&:hover": {
                                          borderColor: "rgba(18, 19, 23, 0.14)",
                                          boxShadow:
                                            "0 8px 20px rgba(18, 19, 23, 0.08)",
                                          transform: "translateY(-1px)",
                                        },
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          gap: 1.25,
                                          alignItems: "flex-start",
                                        }}
                                      >
                                        <Avatargenerator
                                          width="50px"
                                          height="50px"
                                          minWidth="50px"
                                          minHeight="50px"
                                          maxWidth="50px"
                                          maxHeight="50px"
                                          companyname={
                                            userData?.data?.companyName
                                          }
                                          AvatarUrl={
                                            userData?.data?.CompanyAvatar?.url
                                          }
                                        />
                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                          {heading ? (
                                            <Typography
                                              sx={{
                                                fontFamily:
                                                  '"Google Sans Flex", "Inter", sans-serif',
                                                fontWeight: 500,
                                                fontSize: "13px",
                                                lineHeight: 1.4,
                                                color: "#2261a2",
                                              }}
                                            >
                                              {heading}
                                            </Typography>
                                          ) : null}
                                          <Typography
                                            sx={{
                                              fontFamily:
                                                '"Google Sans Flex", "Inter", sans-serif',
                                              fontSize: "12.5px",
                                              lineHeight: 1.45,
                                              color: "#475569",
                                              cursor: "pointer",
                                              transition:
                                                "color 180ms cubic-bezier(0.22, 1, 0.36, 1)",
                                            }}
                                            onClick={() => {
                                              handleClickRedirect({
                                                message: getSafeMessage(item),
                                                userHubType:
                                                  value === "3"
                                                    ? "buyer"
                                                    : value === "4"
                                                      ? "seller"
                                                      : "",
                                                notification: item,
                                              });
                                              handleClose();
                                              clearLocaStorageForBreadCrumb();
                                            }}
                                          >
                                            {maskedMessage}
                                          </Typography>
                                          <Box
                                            sx={{
                                              display: "flex",
                                              flexDirection: "column",
                                              alignItems: "flex-end",
                                              mt: 0.75,
                                              gap: 0.25,
                                            }}
                                          >
                                            <Typography
                                              sx={{
                                                fontFamily:
                                                  '"Google Sans Flex", "Inter", sans-serif',
                                                fontSize: "10px",
                                                color: "#2563eb",
                                                cursor: "pointer",
                                                borderRadius: "999px",
                                                px: 0.8,
                                                py: 0.25,
                                                transition:
                                                  "all 160ms cubic-bezier(0.22, 1, 0.36, 1)",
                                                "&:hover": {
                                                  backgroundColor:
                                                    "rgba(183, 191, 217, 0.1)",
                                                },
                                                "&:active": {
                                                  transform: "translateY(1px)",
                                                },
                                              }}
                                              onClick={() => {
                                                UpdateNotifications(item);
                                                setUpdateNotiticationStatus(
                                                  !UpdateNotiticationStatus,
                                                );
                                                clearLocaStorageForBreadCrumb();
                                              }}
                                            >
                                              {item?.read
                                                ? "Mark as Unread"
                                                : "Mark as Read"}
                                            </Typography>
                                            {formatNotificationReceivedAt(
                                              item?.createdAt,
                                            ) ? (
                                              <Typography
                                                sx={{
                                                  fontFamily:
                                                    '"Google Sans Flex", "Inter", sans-serif',
                                                  fontSize: "10px",
                                                  color: "#94a3b8",
                                                  lineHeight: 1.3,
                                                  whiteSpace: "nowrap",
                                                }}
                                                title={format(
                                                  item?.createdAt,
                                                )}
                                              >
                                                {formatNotificationReceivedAt(
                                                  item?.createdAt,
                                                )}
                                              </Typography>
                                            ) : null}
                                          </Box>
                                        </Box>
                                      </Box>
                                    </Box>
                                  );
                                })
                            ) : (
                              <Box
                                sx={{
                                  borderRadius: "16px",
                                  border: "1px solid rgba(33, 34, 38, 0.06)",
                                  py: 4,
                                  textAlign: "center",
                                  color: "#64748b",
                                  fontFamily:
                                    '"Google Sans Flex", "Inter", sans-serif',
                                  fontSize: "13px",
                                }}
                              >
                                No notifications available
                              </Box>
                            )}
                          </Box>
                        </Box>
                      </Modal>
                    </Box>
                  )}
                  {hasLegacyCartAccess(
                    AuthUserData?.data?.rightsarray,
                    AuthUserData?.data?.superAdmin,
                  ) && (
                    <Link
                      to="/home/cart"
                      onClick={() => {
                        setCartUpdateNotification(false);
                        sendEvents("Click on Cart");
                        clearLocaStorageForBreadCrumb();
                      }}
                    >
                      <Box
                        sx={{
                          ...ButtonsStyle,
                          position: "relative",
                          boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px;",
                        }}
                      >
                        {cartItemCount > 0 ? (
                          <Box
                            sx={{
                              display: "flex",
                              bgcolor: "red",
                              height: { xs: "16px", sm: "17px", md: "18px" },
                              width: { xs: "16px", sm: "17px", md: "18px" },
                              borderRadius: {
                                xs: "8px",
                                sm: "8.5px",
                                md: "9px",
                              },
                              position: "absolute",
                              justifyContent: "center",
                              alignContent: "center",
                              alignItems: "center",
                              top: {
                                xl: "-8px",
                                lg: "-8px",
                                md: "-8px",
                                sm: "-6px",
                                xs: "-6px",
                              },
                              right: {
                                xl: "7px",
                                lg: "7px",
                                md: "7px",
                                sm: "4px",
                                xs: "4px",
                              },
                              zIndex: 1,
                              color: "white",
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: 700,
                                fontSize: {
                                  xs: "8px",
                                  sm: "8.5px",
                                  md: "9px",
                                },
                                lineHeight: 1,
                              }}
                            >
                              {formatBadgeCount(cartItemCount)}
                            </Typography>
                          </Box>
                        ) : cartUpdateNotification ? (
                          <Box
                            sx={{
                              position: "absolute",
                              background: "rgba(230, 46, 123, 1)",
                              height: "10px",
                              width: "10px",
                              borderRadius: "50%",
                              top: "20%",
                              right: "20%",
                            }}
                          />
                        ) : null}
                        <img
                          src={
                            usehubType === "seller"
                              ? Seller_cart_Icon
                              : "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/HeaderIcon/Cart.png"
                          }
                          alt="Cart Icon"
                          title="Cart icon"
                          style={{
                            width: isMobile
                              ? "14px"
                              : isTablet
                                ? "16px"
                                : "18px",
                            height: isMobile
                              ? "14px"
                              : isTablet
                                ? "16px"
                                : "18px",
                            cursor: "pointer",
                          }}
                        />
                      </Box>
                    </Link>
                  )}
                  {!AuthUserData?.data?.superAdmin &&
                  (AuthUserData?.data?.productRights === "NO_ACCESS" ||
                    !hasDashboardPageAccess(
                      AuthUserData?.data?.rightsarray,
                      DASHBOARD_PAGE_KEYS.PROFILE,
                      false,
                    )) ? (
                    <Box
                      sx={{
                        ...ButtonsStyle,
                        display: "flex",
                        width: "auto",
                        flexShrink: 0,
                        justifyContent: "flex-start",
                        alignContent: "center",
                        alignItems: "center",
                        gap: "5px",
                        maxWidth: "220px",
                        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px;",
                      }}
                      onClick={() => {
                        return GlobalToast(
                          "You are not authorized to View Profile",
                          "error",
                        );
                      }}
                    >
                      <Avatargenerator
                        companyname={userData?.data?.companyName}
                        AvatarUrl={userData?.data?.CompanyAvatar?.url}
                      />
                    </Box>
                  ) : (
                    <Link
                      to={"/home/profile"}
                      style={{ textDecoration: "none" }}
                      onClick={() => {
                        clearLocaStorageForBreadCrumb();
                      }}
                    >
                      <Box
                        sx={{
                          ...ButtonsStyle,
                          display: "flex",
                          width: "auto",
                          flexShrink: 0,
                          justifyContent: "flex-start",
                          alignContent: "center",
                          alignItems: "center",
                          gap: { xs: "4px", sm: "4px", md: "5px" },
                          boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px;",
                          height: "100%",
                          minHeight: { xs: "38px", sm: "44px", md: "50px" },
                          minWidth: { xs: "38px", sm: "44px", md: "50px" },
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Avatargenerator
                          width={isMobile ? "36px" : isTablet ? "42px" : "50px"}
                          height={
                            isMobile ? "36px" : isTablet ? "42px" : "50px"
                          }
                          minWidth={
                            isMobile ? "36px" : isTablet ? "42px" : "50px"
                          }
                          minHeight={
                            isMobile ? "36px" : isTablet ? "42px" : "50px"
                          }
                          maxWidth={
                            isMobile ? "36px" : isTablet ? "42px" : "50px"
                          }
                          maxHeight={
                            isMobile ? "36px" : isTablet ? "42px" : "50px"
                          }
                          companyname={userData?.data?.companyName}
                          AvatarUrl={userData?.data?.CompanyAvatar?.url}
                        />
                      </Box>
                    </Link>
                  )}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Paper>
    </React.Fragment>
  );
};

export default Header;

const ButtonsStyle = {
  width: { xl: "38px", lg: "38px", md: "38px", sm: "32px", xs: "32px" },
  height: { xl: "38px", lg: "38px", md: "38px", sm: "32px", xs: "32px" },
  minWidth: { xs: "32px", sm: "32px", md: "38px" },
  minHeight: { xs: "32px", sm: "32px", md: "38px" },
  background: "#FFFFFF",
  display: "flex",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  boxShadow: "0px 2px 5px rgba(38, 51, 77, 0.03)",
  borderRadius: "100px",
  cursor: "pointer",
};

const UserNameTextStyle = {
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "13px",
  lineHeight: "18px",
  textAlign: "center",
  color: "#6B7A99",
};

const style = {
  position: "absolute",
  top: { xs: "50%", sm: "50%", md: "38%" },
  left: { xs: "50%", sm: "50%", md: "79%" },
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "85%", md: "28%" },
  maxWidth: { xs: "400px", sm: "450px", md: "500px" },
  minWidth: { xs: "280px", sm: "300px", md: "250px" },
  height: { xs: "420px", sm: "390px", md: "340px" },
  maxHeight: { xs: "85vh", sm: "82vh", md: "340px" },
  overflow: "hidden",
  bgcolor: "#FFFFFF",
  border: "1px solid rgba(33, 34, 38, 0.06)",
  boxShadow: "0px 20px 44px rgba(18, 19, 23, 0.12)",
  p: { xs: "16px", sm: "18px", md: "20px" },
  borderRadius: { xs: "18px", sm: "20px", md: "22px" },
};

const HeaderIcons = {
  width: "18px",
  height: "18px",
  cursor: "pointer",
};
